import { GetEarlyRepaymentSimulationResponse } from '@iwoca/lapi-client/edge';
import _ from 'lodash';

export function getNumberOfFurtherRepayments(credit_facility_status: {
    response: GetEarlyRepaymentSimulationResponse;
}) {
    return (
        _.get(
            credit_facility_status,
            'response.data.summary.total_number_of_repayments'
        )! - 2
    );
}

export function hasEqualRepaymentsFromSchedule(
    schedule: GetEarlyRepaymentSimulationResponse['data']
) {
    return !!_.get(
        schedule,
        'summary.simplified_schedule.equal_repayments',
        null
    );
}
